import React from "react";
import { Box, Typography, Paper, Button, Stack } from "@mui/material";
import {
  BarChart as StatsIcon,
  PlaylistAdd as BulkIcon,
  Add as AddIcon,
} from "@mui/icons-material";
import { Link as RouterLink } from "react-router-dom";
import TopicStatsTable from "./TopicStatsTable";

const StatsPage: React.FC = () => {
  return (
    <Box>
      <Box
        sx={{
          mb: 3,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexDirection: { xs: "column", sm: "row" },
          gap: 2,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <StatsIcon fontSize="large" />
          <Typography
            variant="h4"
            component="h1"
            sx={{ fontSize: { xs: "1.5rem", sm: "2.125rem" } }}
          >
            問題登録状況
          </Typography>
        </Box>
        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={1}
          width={{ xs: "100%", sm: "auto" }}
        >
          <Button
            variant="outlined"
            startIcon={<BulkIcon />}
            component={RouterLink}
            to="/bulk-add"
            sx={{ width: { xs: "100%", sm: "auto" } }}
          >
            一括生成
          </Button>
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            component={RouterLink}
            to="/opinions/new"
            sx={{ width: { xs: "100%", sm: "auto" } }}
          >
            新規作成
          </Button>
        </Stack>
      </Box>

      <Paper sx={{ p: 3 }}>
        <Typography variant="h6" gutterBottom>
          登録済み問題の分布状況
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          ジャンル別・難易度別の問題登録数（公開済みのみ）
        </Typography>
        <TopicStatsTable />
      </Paper>
    </Box>
  );
};

export default StatsPage;
